import moment from 'moment';
import { format as formatDate, fromUnixTime } from 'date-fns';
import { FallbackPlaceholderText } from '../constants/common';

export const getPreferredDateFormat = (pattern?: DateFormat) => formatMappings[pattern ?? DateFormat.DEFAULT];

export enum DateFormat {
  'DD/MM/YYYY' = 'DD/MM/YYYY',
  'YYYY/MM/DD' = 'YYYY/MM/DD',
  'MM/DD/YYYY' = 'MM/DD/YYYY',
  'DEFAULT' = 'MM/DD/YYYY',
}

const formatMappings: Record<DateFormat, { display: string; partial: string; partialLib: string }> = {
  [DateFormat['DD/MM/YYYY']]: {
    display: 'dd MMMM yyyy',
    partial: 'd MMM y',
    partialLib: 'DD MMM YYYY',
  },
  [DateFormat['YYYY/MM/DD']]: {
    display: 'yyyy MMMM d',
    partial: 'y MMM d',
    partialLib: 'YYYY MMM DD',
  },
  [DateFormat['MM/DD/YYYY']]: {
    display: 'MMMM d, yyyy',
    partial: 'MMM d, y',
    partialLib: 'MMM DD, YYYY',
  },
};

/**
 * Formats a date string based on the provided format.
 */
export const getFormattedDate = (date: string, format: DateFormat): string => {
  const preferredDateFormat = getPreferredDateFormat(format);
  const dateFormat = preferredDateFormat.partialLib;

  return date.includes('Z') ? moment(date).utc().format(dateFormat) : moment(date).format(dateFormat);
};

/**
 * Class for managing user's preferred date format
 */
export class UserDateFormat {
  private static readonly DEFAULT_FORMAT: DateFormat = DateFormat.DEFAULT;

  private static currentFormat: DateFormat = UserDateFormat.DEFAULT_FORMAT;

  public static get(): DateFormat {
    return this.currentFormat;
  }

  public static set(format: DateFormat): void {
    this.currentFormat = format;
  }
}

export const getFormattedDateFromUnix = (date: number, format: string) => {
  if (!date) {
    return FallbackPlaceholderText.DoubleDash;
  }
  return formatDate(fromUnixTime(date), format);
};

export const compareUnixDates = (date1: number, date2: number) => {
  if (date1 === null || date1 === undefined) {
    return 1;
  }
  if (date2 === null || date2 === undefined) {
    return -1;
  }
  return date1 - date2;
};
